import { useQuery } from '@tanstack/react-query';
import Axios from 'axios';

export interface FileResource {
  file: string;
  meta_data?: {
    mime_type?: string;
    status?: string;
    error_code?: number;
  };
  company?: {
    id: string;
  };
}

interface UseFileOptions {
  enabled?: boolean;
  refetchInterval?: number | false;
}

export const useFile = (fileID: string, { enabled, refetchInterval }: UseFileOptions = {}) =>
  useQuery({
    queryKey: [`/v1/files/${fileID}`] as const,
    queryFn: async ({ queryKey: [url] }) => {
      const { data } = await Axios.get<FileResource>(url);
      return data;
    },
    enabled,
    refetchInterval
  });
